import { render, staticRenderFns } from "./UserDashboardCalendar.vue?vue&type=template&id=40d56688&scoped=true&"
import script from "./UserDashboardCalendar.vue?vue&type=script&lang=js&"
export * from "./UserDashboardCalendar.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardCalendar.vue?vue&type=style&index=0&id=40d56688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d56688",
  null
  
)

export default component.exports